import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext(null);

const translations = {
  pt: {
    // Navigation
    home: 'Início',
    createCV: 'Criar CV',
    myCVs: 'Meus CVs',
    backoffice: 'Backoffice',
    login: 'Entrar',
    logout: 'Sair',
    register: 'Registar',
    
    // Hero
    heroTitle: 'Crie o seu CV Profissional',
    heroSubtitle: 'Ferramenta de criação de currículos para recrutamento profissional',
    getStarted: 'Começar Agora',
    
    // Templates
    chooseTemplate: 'Escolha o Template',
    chooseFormat: 'Escolha o Formato do CV',
    outsourcingTemplate: 'Outsourcing',
    outsourcingDesc: '',
    permTemplate: 'Perm',
    permDesc: '',
    
    // Form Labels
    personalInfo: 'Informação Pessoal',
    nameId: 'Nome/ID',
    name: 'Nome/ID',
    yearsExperience: 'Anos de Experiência',
    startYear: 'Ano de Início de Carreira',
    calculatedExperience: 'Experiência Calculada',
    availability: 'Disponibilidade',
    
    // Competencies
    mainCompetencies: 'Competências Principais',
    competencies: 'Competências',
    addCompetency: 'Adicionar Competência',
    selectCompetency: 'Selecionar Competência',
    level: 'Nível',
    
    // Experience
    professionalExperience: 'Experiência Profissional',
    addExperience: 'Adicionar Experiência',
    company: 'Empresa',
    position: 'Cargo',
    startDate: 'Data Início',
    endDate: 'Data Fim',
    currentPosition: 'Posição Atual',
    description: 'Descrição',
    
    // Summary
    professionalSummary: 'Resumo Profissional',
    
    // Education
    educationCertifications: 'Formação e Certificações',
    addEducation: 'Adicionar Formação',
    addCertification: 'Adicionar Certificação',
    institution: 'Instituição',
    degree: 'Grau',
    fieldOfStudy: 'Área de Estudo',
    certificationName: 'Nome da Certificação',
    issuer: 'Entidade Emissora',
    year: 'Ano',
    
    // Languages
    languages: 'Idiomas',
    addLanguage: 'Adicionar Idioma',
    languageName: 'Idioma',
    languageLevel: 'Nível',
    selectLanguage: 'Selecionar Idioma',
    
    // Actions
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    export: 'Exportar',
    exportWord: 'Exportar Word',
    preview: 'Pré-visualizar',
    
    // Backoffice
    competencyManagement: 'Gestão de Competências',
    recruiterManagement: 'Gestão de Recrutadores',
    addNewCompetency: 'Nova Competência',
    keywords: 'Palavras-chave',
    keywordsPlaceholder: 'Separar por vírgula',
    namePT: 'Nome (PT)',
    nameEN: 'Nome (EN)',
    category: 'Categoria',
    actions: 'Ações',
    recruiterEmail: 'Email do Recrutador',
    addRecruiter: 'Adicionar Recrutador',
    recruiters: 'Recrutadores',
    
    // Messages
    saveSuccess: 'Guardado com sucesso!',
    deleteSuccess: 'Eliminado com sucesso!',
    error: 'Ocorreu um erro',
    confirmDelete: 'Tem a certeza que deseja eliminar?',
    
    // Auth
    emailPlaceholder: 'seu@email.com',
    passwordPlaceholder: 'Palavra-passe',
    namePlaceholder: 'O seu nome',
    noAccount: 'Não tem conta?',
    hasAccount: 'Já tem conta?',
    profile: 'Perfil',
    
    // CV List
    noCVs: 'Ainda não criou nenhum CV',
    createFirst: 'Criar o primeiro CV',
    lastUpdated: 'Última atualização',
    
    // Present
    present: 'Presente',
    years: 'anos',
  },
  en: {
    // Navigation
    home: 'Home',
    createCV: 'Create CV',
    myCVs: 'My CVs',
    backoffice: 'Backoffice',
    login: 'Login',
    logout: 'Logout',
    register: 'Register',
    
    // Hero
    heroTitle: 'Create Your Professional CV',
    heroSubtitle: 'Professional resume creation tool for recruitment',
    getStarted: 'Get Started',
    
    // Templates
    chooseTemplate: 'Choose Template',
    chooseFormat: 'Choose CV Format',
    outsourcingTemplate: 'Outsourcing',
    outsourcingDesc: '',
    permTemplate: 'Perm',
    permDesc: '',
    
    // Form Labels
    personalInfo: 'Personal Information',
    nameId: 'Name/ID',
    name: 'Name/ID',
    yearsExperience: 'Years of Experience',
    startYear: 'Career Start Year',
    calculatedExperience: 'Calculated Experience',
    availability: 'Availability',
    
    // Competencies
    mainCompetencies: 'Main Competencies',
    competencies: 'Competencies',
    addCompetency: 'Add Competency',
    selectCompetency: 'Select Competency',
    level: 'Level',
    
    // Experience
    professionalExperience: 'Professional Experience',
    addExperience: 'Add Experience',
    company: 'Company',
    position: 'Position',
    startDate: 'Start Date',
    endDate: 'End Date',
    currentPosition: 'Current Position',
    description: 'Description',
    
    // Summary
    professionalSummary: 'Professional Summary',
    
    // Education
    educationCertifications: 'Education & Certifications',
    addEducation: 'Add Education',
    addCertification: 'Add Certification',
    institution: 'Institution',
    degree: 'Degree',
    fieldOfStudy: 'Field of Study',
    certificationName: 'Certification Name',
    issuer: 'Issuer',
    year: 'Year',
    
    // Languages
    languages: 'Languages',
    addLanguage: 'Add Language',
    languageName: 'Language',
    languageLevel: 'Level',
    selectLanguage: 'Select Language',
    
    // Actions
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    export: 'Export',
    exportWord: 'Export Word',
    preview: 'Preview',
    
    // Backoffice
    competencyManagement: 'Competency Management',
    recruiterManagement: 'Recruiter Management',
    addNewCompetency: 'New Competency',
    keywords: 'Keywords',
    keywordsPlaceholder: 'Separate by comma',
    namePT: 'Name (PT)',
    nameEN: 'Name (EN)',
    category: 'Category',
    actions: 'Actions',
    recruiterEmail: 'Recruiter Email',
    addRecruiter: 'Add Recruiter',
    recruiters: 'Recruiters',
    
    // Messages
    saveSuccess: 'Saved successfully!',
    deleteSuccess: 'Deleted successfully!',
    error: 'An error occurred',
    confirmDelete: 'Are you sure you want to delete?',
    
    // Auth
    emailPlaceholder: 'your@email.com',
    passwordPlaceholder: 'Password',
    namePlaceholder: 'Your name',
    noAccount: "Don't have an account?",
    hasAccount: 'Already have an account?',
    profile: 'Profile',
    
    // CV List
    noCVs: "You haven't created any CVs yet",
    createFirst: 'Create your first CV',
    lastUpdated: 'Last updated',
    
    // Present
    present: 'Present',
    years: 'years',
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('pt'); // Iniciar sempre com português

  const t = (key) => {
    const lang = language || 'pt';
    return translations[lang][key] || key;
  };

  const chooseLanguage = (lang) => {
    setLanguage(lang);
  };

  const resetLanguage = () => {
    setLanguage('pt');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, chooseLanguage, resetLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
